import React, { Component } from 'react';
import { Button } from 'react-bootstrap';
import buildUrl from 'build-url';
import './App.css';
import './vendor/bootstrap/css/bootstrap.min.css';
import Competitors from './components/Competitors.js';
import RoomConfig from './components/RoomConfig.js';
import YourHotel from './components/YourHotel.js';
import ErrorBox from './components/ErrorBox.js';
import logo from './assets/images/atomize_logo.png'

import createBrowserHistory from 'history/createBrowserHistory';
const browserHistory = createBrowserHistory();

const BASE_URL = "https://api.atomize.one";

const MAX_COMPETITORS = 5;
const MIN_LENGTH_FOR_COMPETITOR_SEARCH = 4;
const COMPETITOR_SEARCH_FREQUENCY = 2; // The "keystroke frequency" for competitor searches (1 = every keystroke)
const COMPETITOR_SEARCH_DELAY = 500; // The minimum time (in ms) to wait between competitor searches
const USE_COMPETITOR_SUGGESTIONS = true;
const COMPETITOR_PLACEHOLDER_TEXT = "[Type to find competitor]";

// TODO: where to store this?
const API_KEY = "BdaJEG4bo85cPtbYqKuMU1eXYUW2pbPU9FhMuO0T";

// TODO: this should probably be stored in a resource file of something similar, but this at least keeps them in one place.
const ERROR_MESSAGES = {
    VALID_EMAIL_REQUIRED: "You need to set a valid e-mail address.",
    FIRST_NAME_REQUIRED: "You need to set your first name.",
    LAST_NAME_REQUIRED: "You need to set your last name.",
    PHONE_NUMBER_REQUIRED: "You need to set your phone number.",
    OTA_NAME_REQUIRED: "You need to select your hotel in the list.",
    ONE_RATE_CODE_REQUIRED: "You need to select one rate code for each room type.",
    USES_OTA_REQUIRED: "You need to specify if your hotel has an account at OTA Insight with Rate Insight enabled.",
    COMPETITORS_HAS_TO_BE_UNIQUE: "You have to select unique competitors.",
    TERMS_HAS_TO_BE_APPROVED: "You have to approve Atomize Terms and Conditions."
};

// The below might not be perfect, but should work in most cases (http://emailregex.com)
const EMAIL_REGEX = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/

const COMPETITOR_INPUT_FILTER_FUNC = comp => typeof(comp.value) !== "undefined" &&
    comp.value.toString().length > 0 &&
    comp.value.toString() !== COMPETITOR_PLACEHOLDER_TEXT;

class App extends Component {
    constructor(props) {
        super(props);
        this.state = {
            checksum: window.location.hash.substring(1),
            otaInsightChoices: [],
            otaInsightIdName: {},
            onboardingData: {
                hotelId: -1,
                baseData: {},
                roomTypeData: [],
                rateData: {},
                formSubmitted: false,
                redirectOnSubmittedFormUrl: null
            },
            selectedRateCodeIds: {},
            competitors: [],
            usesClockWbe: "true",
            email: "",
            firstName: "",
            lastName: "",
            phoneNumber: "",
            usesOtaInsight: undefined,
            onboardingFinished: false,
            onboardingErrorMessage: "",
            competitorInputRefs: [],
            loadingOnboardingData: false,
            termsApproved: false,
            submitted: false,
            submitting: false
        };
        this.getonboardingData = this.getOnboardingData.bind(this);
        this.getOtaInsightChoices = this.getOtaInsightChoices.bind(this);
        this.setOtaInsightIdName = this.setOtaInsightIdName.bind(this);
        this.getCompetitorSuggestions = this.getCompetitorSuggestions.bind(this);
        this.updateSelectedRateCodeId = this.updateSelectedRateCodeId.bind(this);
        this.submit = this.submit.bind(this);
        this.getErrorMessages = this.getErrorMessages.bind(this);
        this.readyForSubmit = this.readyForSubmit.bind(this);
        this.updateAccountCreationTime = this.updateAccountCreationTime.bind(this);
        this.updateUsingClockWbe = this.updateUsingClockWbe.bind(this);
        this.addCompetitorRef = this.addCompetitorRef.bind(this);
        this.updateEmail = this.updateEmail.bind(this);
        this.updateFirstName = this.updateFirstName.bind(this);
        this.updateLastName = this.updateLastName.bind(this);
        this.updatePhoneNumber = this.updatePhoneNumber.bind(this);
        this.updateUsesOtaInsight = this.updateUsesOtaInsight.bind(this);
        this.handleTermsAndConditionsCheckedChange = this.handleTermsAndConditionsCheckedChange.bind(this);
        this.validateRateCodeSelection = this.validateRateCodeSelection.bind(this);
        this.validateCompetitorUniqueness = this.validateCompetitorUniqueness.bind(this);
    }

    componentDidMount() {
        this.setState({"loadingOnboardingData": true});
        this.getOnboardingData();
    }

    // TODO: do not reload data if already available
    getOnboardingData() {
        let url = buildUrl(BASE_URL + "/integrations/clock/onboarding", {
            queryParams: {
                checksum: this.state.checksum
            }
        });
        let headers = new Headers();
        headers.append("x-api-key", API_KEY);
        fetch(url, {
            method: 'GET',
            headers: headers,
            mode: 'cors'
        })
        .then(this.handleErrors)
        .then(response => response.json())
        .then(json => {
            if (json.hasOwnProperty("formSubmitted") && json.formSubmitted === true &&
                json.hasOwnProperty("redirectOnSubmittedFormUrl") && json.redirectOnSubmittedFormUrl.length > 0
            ) {
                window.location.href = json.redirectOnSubmittedFormUrl;
            } else {
                this.setState({ onboardingData: json });
                this.getOtaInsightChoices(this.state.onboardingData.baseData.hotelName);
                this.setState({"loadingOnboardingData": false});
            }
        });
    }

    updateSelectedRateCodeId(roomTypeId, rateCodeId) {
        console.log("updateSelectedRateCodeId", roomTypeId, rateCodeId);
        let selectedRateCodeIds = this.state.selectedRateCodeIds;
        selectedRateCodeIds[roomTypeId] = rateCodeId;
        this.setState({ "selectedRateCodeIds": selectedRateCodeIds });
    }

    updateAccountCreationTime(value, formattedValue) {
        let onboardingData = this.state.onboardingData;
        onboardingData.baseData.accountCreationTime = formattedValue;
        this.setState({ "onboardingData": onboardingData });
    }

    updateUsingClockWbe(e) {
        this.setState({ usesClockWbe: e.target.value});
    }

    updateUsesOtaInsight(e) {
        this.setState({"usesOtaInsight": e.currentTarget.value === "true"});
    }

    getOtaInsightHotelSearchUrl(searchText) {
        return buildUrl("https://36df7gtysl.execute-api.eu-west-1.amazonaws.com/prod", {
            queryParams: {
                hn: encodeURIComponent(searchText)
            }
        });
    }

    getOtaInsightChoices(hotelName) {
        let url = this.getOtaInsightHotelSearchUrl(hotelName);
        console.log("Get competitors ", url);

        fetch(url, {
            method: 'GET',
            mode: 'cors'
        })
        .then(this.handleErrors)
        .then(response => response.json())
        .then(json => {
            console.log("Competitors for ", hotelName, json);
            let comps = [];
            json.forEach(comp => {
                comps.push({"name": comp.match, "id": comp.pk});
            });
            console.log(comps);
            this.setState({'otaInsightChoices': comps});
        });
    }

    getOtaInsightChoicesSync(hotelName) {
        let url = this.getOtaInsightHotelSearchUrl(hotelName);
        let request = new XMLHttpRequest();
        request.open("GET", url, false);
        request.send(null);
        console.log(request.responseText);
        let json = JSON.parse(request.responseText);
        return { "otaiId": json[0].pk, "name": json[0].match };
    }

    getCompetitorSuggestions(searchText, callback) {
        let url = this.getOtaInsightHotelSearchUrl(searchText);
        const currentCompetitors = this.state.competitorInputRefs
            .filter(COMPETITOR_INPUT_FILTER_FUNC)
            .map(ci => ci.value);

        fetch(url, {
            method: 'GET',
            mode: 'cors'
        })
        .then(response => {
            if(response.ok) {
                return response.json();
            }
        })
        .then(json => {
            let suggestions = [];
            json.forEach(s => {
                if (typeof(currentCompetitors.find(c => s.match === c)) === "undefined") {
                    suggestions.push({key: s.pk, text: s.match});
                }
            });
            return suggestions;
        })
        .then(suggestions => callback(suggestions))
        .catch(error => console.log("Error when getting search result for " + searchText + ", error message: " + error))
    }

    setOtaInsightIdName(e) {
        let hotelId = typeof(this.state.onboardingData.hotelId) !== "undefined" ? this.state.onboardingData.hotelId : -1;
        console.log('setting ota insight id: ', e.target.value);
        let t = e.target.value.split("||");
        this.setState({ 'otaInsightIdName': { "otaiId": t[0], "name": t[1], "hotelId": hotelId } });
    }

    addCompetitorRef(ref, index) {
        if(ref !== null) {
            let competitorInputRefs = this.state.competitorInputRefs;
            competitorInputRefs[index] = ref;
            this.setState({"competitorInputRefs": competitorInputRefs});
        }
    }

    updateEmail(e) {
        this.setState({"email": e.target.value});
    }

    updateFirstName(e) {
        this.setState({"firstName": e.target.value});
    }

    updateLastName(e) {
        this.setState({"lastName": e.target.value});
    }

    updatePhoneNumber(e) {
        this.setState({"phoneNumber": e.target.value});
    }

    isValidEmail(email) {
        return EMAIL_REGEX.test(email)
    }

    validateRateCodeSelection() {
        let numRoomsWithValidRateCodes = Object.values(this.state.onboardingData.rateData).filter(
            rates => rates && rates.length > 0).length;
        return Object.keys(this.state.selectedRateCodeIds).length === numRoomsWithValidRateCodes;
    }

    handleTermsAndConditionsCheckedChange() {
        this.setState({"termsApproved": !this.state.termsApproved});
    }

    validateCompetitorUniqueness() {
        let competitors = this.state.competitorInputRefs
            .filter(COMPETITOR_INPUT_FILTER_FUNC)
            .map(ci => ci.value);

        if (competitors.length <= 1) {
            return true;
        }

        const competitorLookup = {};
        for (let i = 0; i < competitors.length; i++) {
            if (typeof(competitorLookup[competitors[i]]) !== "undefined") {
                return false;
            }

            competitorLookup[competitors[i]] = i;
        }

        return true;
    }

    getErrorMessages() {
        let validEmailExists = this.isValidEmail(this.state.email);
        let firstNameSet = this.state.firstName.length > 0;
        let lastNameSet = this.state.lastName.length > 0;
        let phoneNumberSet = this.state.phoneNumber.length > 0;
        let otaInsightNameSet = typeof(this.state.otaInsightIdName["otaiId"]) !== "undefined";
        let atLeastOneRateCodeSelected = this.validateRateCodeSelection();
        let usesOtaInsightSet = typeof(this.state.usesOtaInsight) !== "undefined";
        let termsApproved = this.state.termsApproved;
        let competitorsUnique = this.validateCompetitorUniqueness(); // This should really never happen, but is here as a fallback in case something slips through the competitor suggestions

        let errorMessages = [];

        if(!validEmailExists) errorMessages.push(ERROR_MESSAGES.VALID_EMAIL_REQUIRED);
        if(!firstNameSet) errorMessages.push(ERROR_MESSAGES.FIRST_NAME_REQUIRED);
        if(!lastNameSet) errorMessages.push(ERROR_MESSAGES.LAST_NAME_REQUIRED);
        if(!phoneNumberSet) errorMessages.push(ERROR_MESSAGES.PHONE_NUMBER_REQUIRED);
        if(!otaInsightNameSet) errorMessages.push(ERROR_MESSAGES.OTA_NAME_REQUIRED);
        if(!atLeastOneRateCodeSelected) errorMessages.push(ERROR_MESSAGES.ONE_RATE_CODE_REQUIRED);
        if(!usesOtaInsightSet) errorMessages.push(ERROR_MESSAGES.USES_OTA_REQUIRED);
        if(!termsApproved) errorMessages.push(ERROR_MESSAGES.TERMS_HAS_TO_BE_APPROVED);
        if(!competitorsUnique)  errorMessages.push(ERROR_MESSAGES.COMPETITORS_HAS_TO_BE_UNIQUE);

        return errorMessages;
    }

    readyForSubmit() {
        return this.getErrorMessages().length === 0;
    }

    handleErrors(response) {
        if (!response.ok) {
            throw Error(response.statusText);
        }
        return response;
    }

    submit() {
        this.setState({"submitted": true});
        this.setState({"submitting": true});

        let competitors = [];
        if(!this.state.usesOtaInsight) { // No need to add competitors if we can read them directly
        // TODO: better to make this async
            this.state.competitorInputRefs.
                filter(COMPETITOR_INPUT_FILTER_FUNC).
                forEach(comp => {
                    if(!USE_COMPETITOR_SUGGESTIONS) {
                        competitors.push(this.getOtaInsightChoicesSync(comp.value));
                    }
                    else if(typeof(comp.name) !== "undefined" && comp.name.toString().length > 0) {
                        competitors.push({ competitorIdOnProvider: comp.name, name: comp.value });
                    }
            });
        }

        let data = {
            checksum: this.state.checksum,
            hotelId: this.state.onboardingData.hotelId,
            accountCreationTime: this.state.onboardingData.baseData.accountCreationTime.split("T")[0],
            usesClockWbe: this.state.usesClockWbe === "true",
            roomTypeToRateCode: this.state.selectedRateCodeIds,
            otaInsightData: {
                competitorIdOnProvider: this.state.otaInsightIdName.otaiId,
                name: this.state.otaInsightIdName.name,
                hotelId: this.state.otaInsightIdName.hotelId
            },
            competitors: competitors,
            email: this.state.email,
            firstName: this.state.firstName,
            lastName: this.state.lastName,
            phone: this.state.phoneNumber,
            usesOtaInsight: this.state.usesOtaInsight
        };

        let url = buildUrl(BASE_URL + "/integrations/clock/onboarding/finish");
        let headers = new Headers();
        headers.append("x-api-key", API_KEY);
        fetch(url, {
            method: 'POST',
            headers: headers,
            body: JSON.stringify(data),
            mode: 'cors'
        })
        .then(response => {
            if (!response.ok) {
                let errorPage = (
                    <div>
                    <b>Our apologies, but something went wrong with the onboarding process</b>
                    <div>Please contact Atomize at <em>support@atomize.com</em> for further assistance.</div>
                    </div>
                );
                this.setState({"onboardingErrorMessage": errorPage});
                this.setState({"submitted": false});
            } else {
                this.setState({"onboardingFinished": true});
                response.json().then(json => {
                        console.log("Submit response", json);
                        if (json.hasOwnProperty("redirectUrl") && json.redirectUrl.length > 0) {
                            window.location.href = json.redirectUrl;
                        }
                    }
                );
            }

            this.setState({"submitting": false});
        });
    }

    render() {
        let checksum = window.location.hash.substring(1);
        if (this.state.onboardingFinished) {
            return (
                <div className="App" id="wrapper">
                    <h3>Success!</h3>
                    <div>You have now signed up for our services.</div>
                    <div>When everything is ready and set up for your hotel we will notify you via email.</div>
                </div>
            )
        } else if (this.state.onboardingErrorMessage !== "") {
            return (
                <div className="App" id="wrapper">
                    {this.state.onboardingErrorMessage}
                </div>
            )
        } else if (this.state.onboardingData.formSubmitted) {
            return (
                <div className="App" id="wrapper">
                    <div id="page-wrapper">
                        <div className="container-fluid">
                            <img className="App-logo" src={logo} width="400"/>
                            <hr/>
                            <h3>This hotel has already been signed up!</h3>
                            <div>If you have any questions, please contact Atomize at <span className="App-signedupEmail">support@atomize.com</span></div>
                        </div>
                    </div>
                </div>
            )
        } else {
            return (
                <div className="App" id="wrapper">
                    <div id="page-wrapper">
                        <div className="container-fluid">
                            <img className="App-logo" src={logo} width="400"/>
                            { this.state.loadingOnboardingData &&
                                <div className="App-loadingContainer">
                                    <i className="fa fa-spinner fa-spin" />&nbsp;<span className="App-loadingMessage">Loading sign-up data...</span>
                                </div>
                            }

                            { !this.state.loadingOnboardingData &&
                                <div>
                                    <YourHotel baseData={this.state.onboardingData.baseData}
                                               updateAccountCreationTime={this.updateAccountCreationTime}
                                               updateUsingClockWbe={this.updateUsingClockWbe} updateEmail={this.updateEmail}
                                               updateFirstName={this.updateFirstName} updateLastName={this.updateLastName}
                                               updatePhoneNumber={this.updatePhoneNumber}
                                               usesClockWbe={this.state.usesClockWbe}
                                               otaInsightChoices={this.state.otaInsightChoices}
                                               setOtaInsightIdName={this.setOtaInsightIdName}/>
                                    <hr/>
                                    <RoomConfig roomConfig={this.state.onboardingData.roomTypeData}
                                                rateData={this.state.onboardingData.rateData}
                                                updateSelectedRateCodeId={this.updateSelectedRateCodeId}/>
                                    <hr />
                                    <Competitors hotelName={this.state.onboardingData.baseData.hotelName}
                                                 maxCompetitors={MAX_COMPETITORS} competitors={this.state.competitors}
                                                 updateUsesOtaInsight={this.updateUsesOtaInsight} addCompetitorRef={this.addCompetitorRef}
                                                 minLengthForCompetitorSearch={MIN_LENGTH_FOR_COMPETITOR_SEARCH}
                                                 competitorSearchFrequency={COMPETITOR_SEARCH_FREQUENCY}
                                                 competitorSearchDelay={COMPETITOR_SEARCH_DELAY}
                                                 getCompetitorSuggestions={this.getCompetitorSuggestions}
                                                 useCompetitorSuggestions={USE_COMPETITOR_SUGGESTIONS}
                                                 competitorPlaceholderText={COMPETITOR_PLACEHOLDER_TEXT}/>
                                    <hr />
                                    <div className="App-termsAndConditions">
                                        <input type="checkbox" checked={this.state.termsApproved} onChange={this.handleTermsAndConditionsCheckedChange.bind()}/>
                                        <span className="App-termsAndConditionsLabel">I have read and approve <a href="https://atomize.com/terms/" target="_blank">Atomize Terms and Conditions</a></span>
                                    </div>
                                    <ErrorBox header="Missing required information" errorMessages={this.getErrorMessages()} />
                                    <Button disabled={!this.readyForSubmit() || this.state.submitted} onClick={this.submit.bind()}>Sign up</Button>
                                </div>
                            }

                            { this.state.submitting &&
                                <div className="App-loadingContainer">
                                    <i className="fa fa-spinner fa-spin" />&nbsp;<span className="App-loadingMessage">Signing up...</span>
                                </div>
                            }
                        </div>
                    </div>
                </div>
            );
        }
    }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js